import { render, staticRenderFns } from "./DoctorsModuleComponent.vue?vue&type=template&id=54f464f8&scoped=true&"
import script from "./DoctorsModuleComponent.vue?vue&type=script&lang=js&"
export * from "./DoctorsModuleComponent.vue?vue&type=script&lang=js&"
import style0 from "./DoctorsModuleComponent.vue?vue&type=style&index=0&id=54f464f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f464f8",
  null
  
)

export default component.exports